<app-table 	[displayedColumns]="displayedColumns" 
			[columns]="columns" 
			[pageSize]="25" 
			url="/teachers/tests"
			[title]="'teachers-test'|translate"
			sortColumn="created_at"
			sortDirection="desc"
			formLink='/teacher/tests/'
			editParam='uuid'>
</app-table>